import { createReducer } from '@reduxjs/toolkit'
import { getPipelineReportOptionsSuccess } from '../actions/reportingService'

const initialState = {}

export const pipelineReportOptions = createReducer(initialState, {
  [getPipelineReportOptionsSuccess.type]: (state, action) => action.payload
})
